import Swal from "sweetalert2"

export function sweetAlert(type, message) {
    if (type === 'success') {
        return Swal.fire({
            // title: Fa_LAN.sweetAlert.successTitle,
            text: message,
            icon: 'success',
            showConfirmButton: false,
            timer:3000,
        })
    } else {
        return Swal.fire({
            // title: Fa_LAN.sweetAlert.errorTitle,
            text: message,
            icon: 'error',
            showConfirmButton: false,
            timer:3000,
        })
    }
}